import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["strategy", "trackerInstance"];
import { SegmentationFiltersSharedProvider } from './SegmentationFiltersSharedContext';
import { SegmentationFiltersInstanceProvider } from './SegmentationFiltersInstanceContext';
import { jsx as _jsx } from "react/jsx-runtime";
const SegmentationFiltersJoinedProvider = props => {
  const {
      strategy,
      trackerInstance
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(SegmentationFiltersSharedProvider, {
    strategy: strategy,
    trackerInstance: trackerInstance,
    children: /*#__PURE__*/_jsx(SegmentationFiltersInstanceProvider, Object.assign({}, rest, {
      children: props.children
    }))
  });
};
export default SegmentationFiltersJoinedProvider;